import { render, staticRenderFns } from "./LivestreamChatSummary.vue?vue&type=template&id=59ad372c&scoped=true&"
import script from "./LivestreamChatSummary.vue?vue&type=script&lang=js&"
export * from "./LivestreamChatSummary.vue?vue&type=script&lang=js&"
import style0 from "./LivestreamChatSummary.vue?vue&type=style&index=0&id=59ad372c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ad372c",
  null
  
)

export default component.exports